import { jsx as o } from "react/jsx-runtime";
const e = ({ width: t, height: n, className: r }) => /* @__PURE__ */ o(
  "svg",
  {
    className: r,
    fill: "none",
    height: n,
    viewBox: "0 0 6 7",
    width: t,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M2.27822 0.699454C2.59901 0.0840694 3.40099 0.0840684 3.72177 0.699453L5.8871 4.8533C6.20789 5.46868 5.8069 6.23792 5.16532 6.23792H0.834677C0.1931 6.23792 -0.207886 5.46868 0.112902 4.8533L2.27822 0.699454Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  e as Content
};
